<template>
    <my-carousel 
        v-cloak 
        v-if="team.length"
        :per-page-custom="perPage"
        :scroll-per-page="true"
        :pagination-enabled="false"
        :navigation-enabled="true"
        :navigation-next-label="'<span></span>'"
        :navigation-prev-label="'<span></span>'"        
    >
        <slide 
            v-for="(member, index) in team"
            :key="index"
        >
            <div class="agency-team-slide">
                <img class="avatar" :src="member.url" alt="">

                <div class="name">
                    {{ member.nominative }}
                </div>

                <div class="role">
                    {{ member.role }}
                </div>
            </div>
        </slide>
    </my-carousel>
</template>

<script>
import MyCarousel from '../MyCarousel'

export default {
    components: {
        'my-carousel': MyCarousel,
    },

    props:{
        perPage: {
            type: Array,
            default() {
                return [[0, 2], [769, 4]]
            },
        },

        team:{
            type: Array,
            required: true,
        },
    },
}
</script>
